import { render, staticRenderFns } from "./CreateBankForm.vue?vue&type=template&id=4db7bdec&scoped=true&"
import script from "./CreateBankForm.vue?vue&type=script&lang=js&"
export * from "./CreateBankForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateBankForm.vue?vue&type=style&index=0&id=4db7bdec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db7bdec",
  null
  
)

export default component.exports